export * from './user';
export * from './api';
export * from './tracking';

import { apiGetDocs } from '@/utils';
import store from '@/store';
import { bus } from '@/main';

const locumPath = '/locum/profile';
const companyPath = '/company/profile';
const accountSettingPath = '/locum/account-settings';
const userManagementPath = '/company/user-management';

const getMenuLinks = (links, key) => (links && links[key] ? links[key] : 'https://www.locumbase.com' + '/' + key);

export const getNavItems = (userType, showWallet, invitesActive, links) => [
	{
		title: 'Redeem Credits',
		icon: 'question_answer',
		hidden: userType === 'professional' || !showWallet,
		onClick: () => {
			bus.$emit('show-wallet-dialog');
		},
	},
	{
		title: 'Invite Locum',
		icon: 'question_answer',
		hidden: userType === 'professional' || !invitesActive,
		onClick: () => {
			bus.$emit('show-invite-popup');
		},
	},
	{ title: 'Edit Profile', icon: 'question_answer', to: userType === 'professional' ? locumPath : companyPath },
	{ title: 'Account Settings', icon: 'question_answer', to: accountSettingPath },
	{ title: 'User Management', icon: 'question_answer', to: userManagementPath, hidden: userType === 'professional' },
	// {
	// 	title: 'Locum Directory',
	// 	icon: 'question_answer',
	// 	hidden: userType === 'professional',
	// 	onClick: () => {
	// 		Tracking.track('Prac_LocumDirectory_Click');
	// 		bus.$emit('show-featured-popup');
	// 	},
	// },
	{
		title: 'Preview Profile',
		icon: 'question_answer',
		hidden: userType !== 'professional',
		onClick: () => {
			bus.$emit('show-locum-preview-popup');
		},
	},
	{ title: 'FAQ', icon: 'question_answer', href: getMenuLinks(links, 'faq'), target: '_blank' },
	{ title: 'Blog', icon: 'question_answer', href: getMenuLinks(links, 'blog'), target: '_blank' },
	// { title: 'Calendar', icon: 'dashboard', to: '/' },
	{ title: 'Contact Us', icon: 'question_answer', href: getMenuLinks(links, 'contact'), target: '_blank' },
];

export const provinceRegionPairs = [
	{
		province: 'Gauteng',
		region: 'Bronkhorstspruit',
	},
	{
		province: 'Gauteng',
		region: 'Centurion',
	},
	{
		province: 'Gauteng',
		region: 'East Rand',
	},
	{
		province: 'Gauteng',
		region: 'Gauteng South and Midvaal',
	},
	{
		province: 'Gauteng',
		region: 'Johannesburg',
	},
	{
		province: 'Gauteng',
		region: 'Midrand',
	},
	{
		province: 'Gauteng',
		region: 'Pretoria',
	},
	{
		province: 'Gauteng',
		region: 'West Rand',
	},
	{
		province: 'Western Cape',
		region: 'Boland',
	},
	{
		province: 'Western Cape',
		region: 'Cape Town',
	},
	{
		province: 'Western Cape',
		region: 'Central Karoo',
	},
	{
		province: 'Western Cape',
		region: 'Garden Route',
	},
	{
		province: 'Western Cape',
		region: 'Overberg',
	},
	{
		province: 'Western Cape',
		region: 'West Coast',
	},
	{
		province: 'KwaZulu Natal',
		region: 'Dolphin Coast',
	},
	{
		province: 'KwaZulu Natal',
		region: 'Drakensberg',
	},
	{
		province: 'KwaZulu Natal',
		region: 'Durban',
	},
	{
		province: 'KwaZulu Natal',
		region: 'KZN Midlands',
	},
	{
		province: 'KwaZulu Natal',
		region: 'KZN North Coast',
	},
	{
		province: 'KwaZulu Natal',
		region: 'KZN South Coast',
	},
	{
		province: 'KwaZulu Natal',
		region: 'Northern KZN',
	},
	{
		province: 'KwaZulu Natal',
		region: 'Pietermaritzburg',
	},
	{
		province: 'Northern Cape',
		region: 'Kalahari and Green Kalahari',
	},
	{
		province: 'Northern Cape',
		region: 'Karoo',
	},
	{
		province: 'Northern Cape',
		region: 'Kimberley and Diamond Fields',
	},
	{
		province: 'Northern Cape',
		region: 'Namakwa',
	},
	{
		province: 'Free State',
		region: 'Bloemfontein',
	},
	{
		province: 'Free State',
		region: 'Eastern Free State',
	},
	{
		province: 'Free State',
		region: 'Northern Free State',
	},
	{
		province: 'Free State',
		region: 'Southern Free State',
	},
	{
		province: 'Free State',
		region: 'Welkom and Goldfields',
	},
	{
		province: 'Eastern Cape',
		region: 'East London to the Wild Coast',
	},
	{
		province: 'Eastern Cape',
		region: 'Eastern Cape Interior',
	},
	{
		province: 'Eastern Cape',
		region: 'Grahamstown',
	},
	{
		province: 'Eastern Cape',
		region: 'Jeffreys Bay to Tsitsikamma',
	},
	{
		province: 'Eastern Cape',
		region: 'Kenton On Sea',
	},
	{
		province: 'Eastern Cape',
		region: 'Port Alfred',
	},
	{
		province: 'Eastern Cape',
		region: 'Port Elizabeth and Nelson Mandela Bay',
	},
	{
		province: 'Limpopo',
		region: 'Bela-Bela and Bushveld',
	},
	{
		province: 'Limpopo',
		region: 'Burgersfort',
	},
	{
		province: 'Limpopo',
		region: 'Hoedspruit',
	},
	{
		province: 'Limpopo',
		region: 'Makhado and Vhembe District',
	},
	{
		province: 'Limpopo',
		region: 'Phalaborwa',
	},
	{
		province: 'Limpopo',
		region: 'Polokwane (Pietersburg)',
	},
	{
		province: 'Limpopo',
		region: 'Tzaneen and surrounds',
	},
	{
		province: 'North West',
		region: 'Brits',
	},
	{
		province: 'North West',
		region: 'Hartbeespoort Dam',
	},
	{
		province: 'North West',
		region: 'Klerksdorp',
	},
	{
		province: 'North West',
		region: 'North West',
	},
	{
		province: 'North West',
		region: 'Potchefstroom',
	},
	{
		province: 'North West',
		region: 'Rustenburg',
	},
	{
		province: 'North West',
		region: 'Vryburg',
	},
	{
		province: 'Mpumalanga',
		region: 'Highveld, Grass and Wetlands',
	},
	{
		province: 'Mpumalanga',
		region: 'Lowveld and Kruger Park',
	},
	{
		province: 'Mpumalanga',
		region: 'Middelburg',
	},
	{
		province: 'Mpumalanga',
		region: 'Witbank',
	},
];

export const getRelevantProfessions = (userProfile, industriesConfigsObj) => {
	if (!industriesConfigsObj || Object.keys(industriesConfigsObj).length === 0) return [];
	// For Pharmacy practices, locums required include Pharmacy & Nursing professions
	let nursingProfessions = [];
	if (userProfile === 'Pharmacy') {
		nursingProfessions = industriesConfigsObj['Nursing'];
	}
	// For all other practices, locum professions required from relevant industry
	let professionOptions = industriesConfigsObj[userProfile];

	if (!nursingProfessions) return professionOptions;

	return nursingProfessions.concat(professionOptions);
};

export const getAllIndustriesProfessions = industriesConfigsObj => {
	let allProfessions = [];
	const listOfIndustries = Object.keys(industriesConfigsObj);
	for (const industry of listOfIndustries) {
		allProfessions.push({ industry: industry, expertise: 'not specified' });
		let professions = industriesConfigsObj[industry];
		for (const profession of professions) {
			allProfessions.push({ industry: industry, expertise: profession });
		}
	}
	allProfessions.push({ industry: 'not specified', expertise: 'not specified' });
	return allProfessions;
};

export const getLocumAvatar = async userId => {
	let logo = '';
	try {
		const response = await apiGetDocs('images/avatar/' + userId);
		logo = 'data:image/png;base64,' + response.data.data;
	} catch (err) {
		console.error('Error msg: ', err);
	}
	return logo;
};

export const getProfileProgressPercentage = () => {
	// let total = store.getters.stepsRequired.length + store.getters.stepsBoosted.length;
	let count = 0;
	store.getters.stepsRequired.forEach(step => {
		if (step.status) {
			count++;
		}
	});
	store.getters.stepsBoosted.forEach(step => {
		if (step.status) {
			count++;
		}
	});
	return Math.min(100, count * 10 + 10 + (store.getters.getIsApproved ? 10 : 0) + (store.getters.currentStep == 'completed-step' ? 10 : 0)); //+10 for initial step thats guarenteed to be done
};
